import { Avatar, ResourceItem, ResourceList, Text, TextField } from "@shopify/polaris";
import React, { useCallback, useState } from "react";
import useChatChannelList from "src/components/shopify/hook/useChatChannelList";
import { ChatMessageContent } from "src/graphql/codegen_graphql";

export function handleMessageText(message: ChatMessageContent | any) {
  if (message) {
    let messageText = (message && message.text) ? message.text : '';

    if (message.attachments !== null) {
      if ((message.attachments || []).length > 0 && messageText === '') {
        switch ((message.attachments as any)[0].type) {
          case 'AUDIO':
            messageText = '🎤 Voice message';
            break;
          case 'FILE':
            messageText = '📂 Sent file';
            break;
          case 'IMAGE':
            messageText = '🖼️ Sent picture';
            break;
          case 'PACKAGE':
            messageText = '📦 Sent package';
            break;
          case 'LOCATION':
            messageText = '📍 Sent location';
            break;
          case 'PRODUCT':
            messageText = '🏷️ Sent product';
            break;
          case 'CUSTOMER_ORDER':
            messageText = '🛒 Sent Order';
            break;
          default:
            messageText = '💬 Sent new message';
            break;
        }
      } else if (message.packageId) {
        messageText = '📦 Sent package';
      } else if (message.productId) {
        messageText = '🏷️ Sent product';
      }
    }
    return messageText
  }
  return ''
}

export function ChatList() {
  const [searchInput, setSearchInput] = useState("");
  const { list, loading } = useChatChannelList();
  const [data, setData] = useState(list || []);

  const searchText = useCallback(
    (value) => {
      setSearchInput(value);
      if (value === "") {
        return setData([]);
      }
      const filterRegex = new RegExp(value, "i");
      setData(list.filter((x) => x.name?.match(filterRegex)));
    },
    [list],
  );

  const ActiveStatus = ({ status }: { status: string }) => {
    const isActive = status.toLowerCase() === "active now";
    return (
      <div
        style={{
          backgroundColor: isActive ? "#30cc45" : "#ddd",
          width: 10,
          height: 10,
          borderRadius: "50%",
          marginRight: "0.5rem",
          position: "absolute",
          bottom: -1,
          right: -10,
        }}
      ></div>
    );
  };

  return (
    <div style={{ flexDirection: "row" }}>
      <TextField
        value={searchInput}
        onChange={searchText}
        autoComplete="off"
        label=""
        labelHidden
        placeholder="Search phone number..."
      />
      <br />
      <ResourceList
        items={searchInput ? data : list}
        loading={loading}
        renderItem={(item) => {
          const media = (
            <div style={{ position: "relative" }}>
              <Avatar customer name={item.name || ""} source={item.image || ""} />
              <ActiveStatus status={item.onlineStatus || ""} />
            </div>
          );
          return (
            <ResourceItem
              id={item.channel + ""}
              media={media}
              onClick={() => { }}
              url={`/chat?channel=${item.channel}&name=${item.name}`}
              external={window.location.pathname.split("/")[1] !== "chat"}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <Text variant="bodySm" fontWeight="bold" as="h3">
                  {item.name}
                </Text>
              </div>
              <small style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                {handleMessageText(item.lastMessage)}
              </small>
            </ResourceItem>
          );
        }}
      />
    </div>
  );
}
